export const getSidebarData = (isAdmin, isTeamLead) => [
    {
        "title": "",
        "childrens": [
            {
                "title": "Overview",
                "icon": "bi-asterisk",
                "path": "/over-view"
            },
            ...(isAdmin || isTeamLead
                ? [{
                    "title": "Users",
                    "icon": "bi-person-fill",
                    "path": "/users"
                }]
                : []),
            ...(isAdmin
                ? [{
                    "title": "Teams",
                    "icon": "bi-people-fill",
                    "path": "/teams"
                }]
                : []),
            {
                "title": "Documents",
                "icon": "bi-file-earmark-bar-graph-fill",
                "path": "/documents"
            },
            {
                "title": "Resources",
                "icon": "bi-border-style",
                "path": "/resources"
            },
            ...(isAdmin || isTeamLead
                ? [{
                    "title": "Translation",
                    "icon": "bi-translate",
                    "path": "/new-translation"
                }, {
                    "title": "Recent Translation",
                    "icon": "bi-list-ul",
                    "path": "/recent-translation"
                }]
                : []),
            {
                "title": "Post Editing",
                "icon": "bi-credit-card-2-front",
                "path": "/post-editing"
            },
            {
                "title": "Profile",
                "icon": "bi-person-fill",
                "path": "/profile"
            },
            ...(isAdmin
                ? [{
                    "title": "Activity Logs",
                    "icon": "bi-clock-history",
                    "path": "/logs"
                }]
                : []),
            {
                "title": "Logout",
                "icon": "bi-box-arrow-right",
                "path": "/logout"
            }
        ]
    }
];
